import { useTranslation } from 'react-i18next'

import { useSaleProducts } from '@entities/Product'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'



import { IMAGE_SIZES, URL_CATEGORY_SALE_PRODUCTS } from '@shared/contants'

import type { Product } from '@@types'


export default function ProductsCarouselSales () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()

  const { saleProducts, loading } = useSaleProducts({
    shop_id: shopId,
    style: IMAGE_SIZES.TABLET,
    page: 1,
    limit: 20,
  })

  return (
    <>
      {saleProducts.length > 0 && (
        <ProductCarousel
          link={URL_CATEGORY_SALE_PRODUCTS}
          title={tp('sales')}
          products={saleProducts as Product[]}
          loading={loading}
        />
      )}
    </>
  )
}
